import {useEffect, useState} from "react";
import Loading from "../Loading/Loading";
import {getAllCustomersObjectDividedByBlockArea} from "../../pages/Customers/functions";
import {TreeSelectWithoutContainer} from "../TreeSelect/TreeSelect";
import {listToTree} from "../../assets/functions";
import {convertExceptionPersonToArray} from "./functions";

const ExceptionPersonForm = ({exceptionPerson , onChange}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [allCustomersDividedByAreaBlock , setAllCustomersDividedByAreaBlock] = useState([]);

    const defaultExceptionPerson = {
        isAllCustomer: "FALSE",
        includeCustomerAreaBlock: [],
        excludeCustomerAreaBlock: [],
        includeCustomerTown: [],
        excludeCustomerTown: [],
        includeCustomerId: [],
        excludeCustomerId: [],
    }

    useEffect(() => {
        (async () => {
            const allCustomersDividedByAreaBlock = await getAllCustomersObjectDividedByBlockArea();
            setAllCustomersDividedByAreaBlock(allCustomersDividedByAreaBlock);
            setIsLoading(false);
        })();

    }, []);

    if (isLoading)
        return <Loading/>


    return (
        <div className={"row"}>
            <div className="card">
                <div className="card-body">
                    <label className={"card-title d-block"}>محدودیت برای کاربران</label>
<TreeSelectWithoutContainer data={listToTree(allCustomersDividedByAreaBlock , convertExceptionPersonToArray(exceptionPerson))} onChange={(value) => {
                        const newExceptionPerson = {...defaultExceptionPerson};
                        console.log(value);
                        for (let i = 0; i < value.length; i++) {
                            if (value[i] == "ALL_CUSTOMERS"){
                                newExceptionPerson.isAllCustomer = "TRUE";
                                newExceptionPerson.includeCustomerAreaBlock = [];
                                newExceptionPerson.excludeCustomerAreaBlock = [];
                                newExceptionPerson.includeCustomerTown = [];
                                newExceptionPerson.excludeCustomerTown = [];
                                newExceptionPerson.includeCustomerId = [];
                                newExceptionPerson.excludeCustomerId = [];
                            }else if (typeof value[i] === 'number'){
                                // townId
                                newExceptionPerson.isAllCustomer = "FALSE";
                                newExceptionPerson.includeCustomerTown = [...newExceptionPerson.includeCustomerTown , value[i] ];
                            }else if (value[i].includes("_")){
                                // CustomerId
                                newExceptionPerson.isAllCustomer = "FALSE";
                                newExceptionPerson.includeCustomerId = [...newExceptionPerson.includeCustomerId , value[i] ];
                            }else {
                                newExceptionPerson.isAllCustomer = "FALSE";
                                newExceptionPerson.includeCustomerAreaBlock = [...newExceptionPerson.includeCustomerAreaBlock , value[i] ];
                            }
                        }

                        console.log(newExceptionPerson);
                        onChange(newExceptionPerson);
                    }} />
                </div>
            </div>
        </div>
    );
}


export const ExceptionPersonFormWithoutContainer = ({exceptionPerson , onChange}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [allCustomersDividedByAreaBlock , setAllCustomersDividedByAreaBlock] = useState([]);

    const defaultExceptionPerson = {
        isAllCustomer: "FALSE",
        includeCustomerAreaBlock: [],
        excludeCustomerAreaBlock: [],
        includeCustomerTown: [],
        excludeCustomerTown: [],
        includeCustomerId: [],
        excludeCustomerId: [],
    }

    useEffect(() => {
        (async () => {
            const allCustomersDividedByAreaBlock = await getAllCustomersObjectDividedByBlockArea();
            setAllCustomersDividedByAreaBlock(allCustomersDividedByAreaBlock);
            setIsLoading(false);
        })();

    }, []);

    if (isLoading)
        return <Loading/>


    return (
        <div className={"row"}>
            <label className={"card-title d-block"}>محدودیت برای کاربران</label>
            <TreeSelectWithoutContainer data={listToTree(allCustomersDividedByAreaBlock , convertExceptionPersonToArray(exceptionPerson))} onChange={(value) => {
                const newExceptionPerson = {...defaultExceptionPerson};

                for (let i = 0; i < value.length; i++) {
                    if (value[i] == "ALL_CUSTOMERS"){
                        newExceptionPerson.isAllCustomer = "TRUE";
                        newExceptionPerson.includeCustomerAreaBlock = [];
                        newExceptionPerson.excludeCustomerAreaBlock = [];
                        newExceptionPerson.includeCustomerTown = [];
                        newExceptionPerson.excludeCustomerTown = [];
                        newExceptionPerson.includeCustomerId = [];
                        newExceptionPerson.excludeCustomerId = [];
                    }else if (typeof value[i] === 'number'){
                        // townId
                        newExceptionPerson.isAllCustomer = "FALSE";
                        newExceptionPerson.includeCustomerTown = [...newExceptionPerson.includeCustomerTown , value[i] ];
                    }else if (value[i].includes("_")){
                        // CustomerId
                        newExceptionPerson.isAllCustomer = "FALSE";
                        newExceptionPerson.includeCustomerId = [...newExceptionPerson.includeCustomerId , value[i] ];
                    }else {
                        newExceptionPerson.isAllCustomer = "FALSE";
                        newExceptionPerson.includeCustomerAreaBlock = [...newExceptionPerson.includeCustomerAreaBlock , value[i] ];
                    }
                }


                onChange(newExceptionPerson);
            }} />
        </div>
    );
}

export default ExceptionPersonForm;